<template>
  <page-container3>
    <div class="ant-pro-table">
      <div class="ant-pro-table-search">
        <search-render
          ref="config_render"
          :form="config"
          :model="config.model"
          :options="config_options"
          :validateInfos="validateInfos"
          @search="search"
        />
      </div>
      <a-card :body-style="{ padding: 0 }" ref="elRef">
        <div class="ant-pro-table-list-toolbar">
          <div class="ant-pro-table-list-toolbar-container">
            <div class="ant-pro-table-list-toolbar-left">
              <div class="ant-pro-table-list-toolbar-title">接口列表</div>
            </div>
            <div class="ant-pro-table-list-toolbar-right">
              <a-space align="center">
                <a-button
                  type="primary"
                  size="small"
                  @click="
                    () => {
                      editModal.visible = true;
                      editModal.title = '新建接口';
                      editModal.form.model = {};
                    }
                  "
                >
                  <plus-outlined />
                  新建接口
                </a-button>
                <a-button
                  type="primary"
                  size="small"
                  @click="
                    () => {
                      importModal.visible = true;
                      importModal.title = '导入接口';
                      importModal.form.model = {};
                    }
                  "
                >
                  <plus-outlined />
                  导入接口
                </a-button>
                <div class="ant-pro-table-list-toolbar-setting-item">
                  <a-tooltip title="表格斑马纹">
                    <a-switch
                      checked-children="开"
                      un-checked-children="关"
                      v-model:checked="state.stripe"
                    />
                  </a-tooltip>
                </div>
              </a-space>
              <div class="ant-pro-table-list-toolbar-divider">
                <a-divider type="vertical" />
              </div>
              <div class="ant-pro-table-list-toolbar-setting-item">
                <a-tooltip title="刷新">
                  <reload-outlined @click="handleTableChange" />
                </a-tooltip>
              </div>
              <div class="ant-pro-table-list-toolbar-setting-item">
                <a-tooltip title="密度">
                  <a-dropdown :trigger="['click']" placement="bottomRight">
                    <column-height-outlined />
                    <template #overlay>
                      <a-menu
                        style="width: 80px"
                        :selected-keys="[state.tableSize]"
                        @click="
                          ({ key }) => {
                            state.tableSize = key;
                          }
                        "
                      >
                        <a-menu-item key="default">
                          <a href="javascript:;">默认</a>
                        </a-menu-item>
                        <a-menu-item key="middle">
                          <a href="javascript:;">中等</a>
                        </a-menu-item>
                        <a-menu-item key="small">
                          <a href="javascript:;">紧凑</a>
                        </a-menu-item>
                      </a-menu>
                    </template>
                  </a-dropdown>
                </a-tooltip>
              </div>
              <div class="ant-pro-table-list-toolbar-setting-item">
                <a-popover
                  placement="bottomRight"
                  arrowPointAtCenter
                  trigger="click"
                  overlayClassName="ant-pro-table-column-setting-overlay"
                >
                  <template #title>
                    <div class="ant-pro-table-column-setting-title">
                      <a-checkbox
                        v-model:checked="columnState.checkAll"
                        :indeterminate="columnState.indeterminate"
                        @change="handleColumnAllClick"
                      >
                        列展示
                      </a-checkbox>
                      <a @click="reset">重置</a>
                    </div>
                  </template>
                  <template #content>
                    <span class="ant-pro-table-column-setting-list">
                      <drag-container
                        lockAxis="y"
                        dragClass="ant-pro-table-drag-ghost"
                        dropClass="ant-pro-table-drop-ghost"
                        @drop="({ removedIndex, addedIndex }) => move(removedIndex, addedIndex)"
                      >
                        <draggable :key="column.key" v-for="column in dynamicColumnItems">
                          <div class="ant-pro-table-column-setting-list-item">
                            <drag-icon />
                            <a-checkbox
                              :checked="column.checked"
                              @change="handleColumnChange($event, column)"
                            >
                              {{ column.label }}
                            </a-checkbox>
                          </div>
                        </draggable>
                      </drag-container>
                    </span>
                  </template>
                  <a-tooltip title="列设置">
                    <setting-outlined />
                  </a-tooltip>
                </a-popover>
              </div>
              <div class="ant-pro-table-list-toolbar-setting-item">
                <a-tooltip :title="screenState ? '退出全屏' : '全屏'">
                  <fullscreen-outlined v-if="!screenState" @click="setFull" />
                  <fullscreen-exit-outlined v-else @click="exitFull" />
                </a-tooltip>
              </div>
            </div>
          </div>
        </div>
        <a-affix :offset-top="top">
          <a-table
            bordered
            :scroll="{ y: tableHeight.y }"
            :row-class-name="stripe"
            :size="state.tableSize"
            :loading="state.loading"
            :columns="dynamicColumns"
            :data-source="state.dataSource"
            :pagination="{
              current: state.current,
              pageSize: state.pageSize,
              total: state.total,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ['20', '50', '100', '200'],
            }"
            @change="handleTableChange"
          >
            <template #index="{ index }">
              <span>{{ index + 1 + state.pageSize * (state.current - 1) }}</span>
            </template>
            <template #menu_list="{ record }">
              <span v-for="obj in record.menu_list" :key="obj.id">
                <a-tag color="#87d068" style="margin-bottom: 1px" v-if="obj.parent_name">
                  {{ obj.parent_name }}&nbsp;>&nbsp;{{ obj.name }}
                </a-tag>
                <a-tag color="#87d068" style="margin-bottom: 1px" v-if="!obj.parent_name">
                  {{ obj.name }}
                </a-tag>
              </span>
            </template>
            <template #name="{ text, record }">
              <div class="editable-cell">
                <div v-if="editableData[record.id]" class="editable-cell-input-wrapper">
                  <a-input
                    v-model:value="editableData[record.id].name"
                    @pressEnter="save(record.id)"
                  />
                  <check-outlined class="editable-cell-icon-check" @click="save(record.id)" />
                </div>
                <div v-else class="editable-cell-text-wrapper" @click="edit(record.id)">
                  {{ text || ' ' }}
                  <edit-outlined class="editable-cell-icon" @click="edit(record.id)" />
                </div>
              </div>
            </template>
            <template #status="{ text }">
              <a-tag :color="statusMap[text].status">
                {{ statusMap[text].text }}
              </a-tag>
            </template>
            <template #action="{ record }">
              <a-button
                type="primary"
                @click="() => handleOpenEdit(record)"
                v-if="record.is_active"
                size="small"
              >
                修改
              </a-button>
              <a-popconfirm v-if="record.is_active" @confirm="() => handleDelete(record)">
                <template #title>
                  <p>
                    是否确认删除
                    <span style="color: dodgerblue">{{ record.name }}</span>
                    接口?
                  </p>
                </template>
                <a-button type="danger" size="small">删除</a-button>
              </a-popconfirm>
              <a-button
                type="danger"
                @click="() => handleRecover(record)"
                v-if="!record.is_active"
                size="small"
              >
                恢复
              </a-button>
              <a-button
                type="primary"
                @click="() => handleChangeApiurlAuth(record, true)"
                v-if="record.is_active && !record.is_auth"
                size="small"
              >
                设为需要授权
              </a-button>
              <a-button
                type="danger"
                @click="() => handleChangeApiurlAuth(record, false)"
                v-if="record.is_active && record.is_auth"
                size="small"
              >
                设为无需授权
              </a-button>
            </template>
          </a-table>
        </a-affix>
      </a-card>
    </div>
    <form-modal
      v-bind="editModal"
      v-if="editModal.visible"
      @cancel="
        () => {
          editModal.visible = false;
        }
      "
      @ok="handlerOk"
    />
    <form-modal
      v-bind="importModal"
      v-if="importModal.visible"
      @cancel="
        () => {
          importModal.visible = false;
        }
      "
      @ok="handlerImport"
    />
  </page-container3>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive } from 'vue';
import { Badge, message } from 'ant-design-vue';
import {
  PlusOutlined,
  ReloadOutlined,
  ColumnHeightOutlined,
  SettingOutlined,
  FullscreenOutlined,
  FullscreenExitOutlined,
} from '@ant-design/icons-vue';
import { Container as DragContainer, Draggable } from '@/components/draggable';
import {
  queryApiurl,
  addURL,
  updateUrl,
  removeUrl,
  recoverUrl,
  import_apiurl,
  change_apiurl_auth,
} from '@/api/permission/apiurl-manage.ts';
import { Pagination, TableFilters, TableColumn, TableColumnSortOrder } from '@/typing';
import { useFetchData } from '@/utils/hooks/useFetchData';
import { useFullscreen } from '@/utils/hooks/useFullscreen';
import { useTableDynamicColumns } from '@/utils/hooks/useTableColumn';
import DragIcon from '@/components/table/drag-icon.vue';
import { useStore } from 'vuex';
import SearchRender from '@/components/FormRender/SearchRender.vue';
import FormModal from '../../../components/form-modal/form-modal.vue';
import { useForm } from 'ant-design-vue/es/form';
import { EditOutlined, CheckOutlined } from '@ant-design/icons-vue';
const statusMap = {
  true: { text: '正常', status: 'green' },
  false: { text: '作废', status: 'red' },
};
const baseColumns: TableColumn[] = [
  {
    title: '序号',
    width: 50,
    dataIndex: 'index',
    slots: { customRender: 'index' },
  },
  {
    title: '名称',
    dataIndex: 'name',
    slots: { customRender: 'name' },
  },
  {
    title: 'url',
    dataIndex: 'url',
  },
  {
    title: '接口对应菜单',
    dataIndex: 'menu_list',
    slots: { customRender: 'menu_list' },
  },
  {
    title: '状态',
    width: 70,
    dataIndex: 'is_active',
    slots: { customRender: 'status' },
    filters: [
      {
        text: status[0],
        value: true,
      },
      {
        text: status[1],
        value: false,
      },
    ],
  },
  {
    title: '操作',
    width: 350,
    dataIndex: 'action',
    slots: { customRender: 'action' },
  },
];

export default defineComponent({
  name: 'ApiurlManage-1',
  setup() {
    const store = useStore();
    const current_org = store.getters['user/current_org'];
    const tableHeight = reactive({ y: window.innerHeight - 130 });
    const editableData: any = reactive({});

    onMounted(() => {
      window.onresize = function () {
        tableHeight.y = window.innerHeight - 130;
      };
    });
    const {
      state: columnState,
      dynamicColumns,
      dynamicColumnItems,
      handleColumnAllClick,
      handleColumnChange,
      reset,
      move,
    } = useTableDynamicColumns(baseColumns, true);
    const [elRef, screenState, { setFull, exitFull }] = useFullscreen();

    const modelRef = reactive({
      org_id: current_org.id,
      is_active: true,
      is_auth: '',
      name: '',
    });
    const {
      stripe,
      reload,
      setPageInfo,
      context: state,
    } = useFetchData(queryApiurl, {
      current: 1,
      pageSize: 20,
      tableSize: 'middle', // 'default' | 'middle' | 'small'
      stripe: true,
      requestParams: {
        ...modelRef,
      },
    });
    const handleTableChange = (
      { current, pageSize }: Pagination,
      filters: TableFilters,
      sorter: TableColumnSortOrder,
    ) => {
      console.log(sorter);
      setPageInfo({
        current,
        pageSize,
        ...filters,
        ...modelRef,
      });

      reload();
    };

    const search = () => {
      setPageInfo({
        current: 1,
        ...modelRef,
      });
      reload();
    };
    // edit
    let currentRecord = reactive({ name: '' });
    const handleOpenEdit = (record: any) => {
      editModal.visible = true;
      editModal.title = '修改接口';
      editModal.form.model = {
        ...record,
      };
      currentRecord = record;
    };
    const handleDelete = (record: any) => {
      removeUrl({ org_id: current_org.id, apiurl_id: record.id }).then(res => {
        message.success('删除接口成功');
        Object.assign(record, res);
      });
    };
    const handleRecover = (record: any) => {
      recoverUrl({ org_id: current_org.id, apiurl_id: record.id }).then(res => {
        message.success('恢复接口成功');
        Object.assign(record, res);
      });
    };

    const handlerOk = (data: any) => {
      if (!editModal.form.model.id) {
        addURL({ org_id: current_org.id, ...data }).then(() => {
          message.success('新增接口成功');
          reload();
        });
      } else {
        updateUrl({
          ...data,
          org_id: current_org.id,
          apiurl_id: data.id,
        }).then((res: any) => {
          Object.assign(currentRecord, res);
          message.success('修改接口成功');
        });
      }
      editModal.visible = false;
    };
    const handlerImport = (data: any) => {
      import_apiurl({ org_id: current_org.id, ...data }).then(() => {
        importModal.visible = false;
        message.success('新增接口成功');
        reload();
      });
    };
    const config = {
      settings: {
        name: '表单名称',
        labelAlign: 'right',
        layout: 'inline',
      },
      fields: [
        {
          type: 'input',
          name: 'name',
          label: '接口名称',
          disabled: false,
          allowClear: true,
          inputType: 'text',
          maxlength: 100,
          defaultValue: '',
          placeholder: '请填写接口名称',
        },
        {
          type: 'select',
          name: 'is_auth',
          label: '是否需要授权',
          disabled: false,
          labelKey: 'name',
          valueKey: 'value',
          placeholder: '请选择是否授权',
          datasource: 'is_auth',
          mode: 'default',
        },
        {
          type: 'select',
          name: 'is_active',
          label: '状态',
          disabled: false,
          defaultValue: '',
          labelKey: 'name',
          valueKey: 'value',
          placeholder: '请选择状态',
          datasource: 'is_active',
          mode: 'default',
        },
      ],
      rules: {},
      model: modelRef,
    };
    const { validateInfos } = useForm(modelRef, {});
    const config_options = {
      is_active: [
        { name: '全部', value: '' },
        { name: '正常', value: true },
        { name: '作废', value: false },
      ],
      is_auth: [
        { name: '全部', value: '' },
        { name: '是', value: true },
        { name: '否', value: false },
      ],
    };

    const edit_model_config = {
      settings: {
        name: '表单名称',
        labelAlign: 'right',
        layout: 'horizontal',
        labelCol: {
          span: 6,
        },
        wrapperCol: {
          span: 18,
        },
      },
      fields: [
        {
          type: 'input',
          name: 'name',
          label: '接口名称',
          disabled: false,
          allowClear: true,
          inputType: 'text',
          maxlength: 100,
          defaultValue: '',
          placeholder: '接口名称',
        },
        {
          type: 'input',
          name: 'url',
          label: '绝对路径',
          disabled: false,
          allowClear: true,
          inputType: 'text',
          maxlength: 100,
          defaultValue: '',
          placeholder: '绝对路径',
        },
        {
          type: 'select',
          name: 'is_auth', // 传值字段
          label: '是否需要授权',
          disabled: false,
          labelKey: 'name', // options数据
          valueKey: 'value',
          placeholder: '请选择是否授权',
          datasource: 'is_auth', // 接参字段
          mode: 'default',
        },
      ],
      rules: {
        name: [{ required: true, message: '请输入接口名称' }],
        url: [{ required: true, message: '请输入绝对路径' }],
      },
      model: {
        id: null,
        name: '',
        url: '',
      },
    };

    const import_model_config = {
      settings: {
        name: '导入api接口json文件',
        labelAlign: 'right',
        layout: 'horizontal',
      },
      fields: [
        {
          type: 'textarea',
          name: 'api_json',
          label: '接口JSON',
          disabled: false,
          allowClear: true,
          inputType: 'text',
          maxlength: 100,
          defaultValue: '',
          placeholder: '接口JSON',
        },
      ],
      rules: {
        api_json: [{ required: true, message: '请输入接口JSON' }],
      },
      model: {
        api_json: '',
      },
    };
    const importModal = reactive({
      visible: false,
      title: '',
      aim_org_id: '',
      form: import_model_config,
      options: {},
    });

    const edit_model_config_options = {
      is_auth: [
        { name: '是', value: true },
        { name: '否', value: false },
      ],
    };
    const editModal = reactive({
      visible: false,
      title: '',
      aim_org_id: '',
      form: edit_model_config,
      options: edit_model_config_options,
    });

    const handleChangeApiurlAuth = (record: any, is_auth: boolean) => {
      change_apiurl_auth({ org_id: current_org.id, apiurl_id: record.id, is_auth: is_auth }).then(
        res => {
          message.success('操作成功');
          Object.assign(record, res);
        },
      );
    };
    const edit = (id: any) => {
      editableData[id] = state.dataSource.filter((item: any) => id === item.id)[0];
    };

    const save = (id: any) => {
      Object.assign(state.dataSource.filter((item: any) => id === item.id)[0], editableData[id]);
      updateUrl({
        org_id: current_org.id,
        apiurl_id: id,
        name: editableData[id].name,
      }).then((res: any) => {
        Object.assign(currentRecord, res);
        message.success('修改接口成功');
      });
      delete editableData[id];
    };
    return {
      statusMap,
      tableHeight,
      state,
      stripe,
      columnState,
      dynamicColumns,
      dynamicColumnItems,

      modelRef,
      // fullscreen
      elRef,
      screenState,
      setFull,
      exitFull,

      handleTableChange,
      search,

      handleColumnChange,
      handleColumnAllClick,
      reset,
      move,

      // edit
      importModal,
      handlerImport,
      editModal,
      handleOpenEdit,
      edit_model_config,
      edit_model_config_options,

      config,
      config_options,
      validateInfos,

      handlerOk,
      handleDelete,
      handleRecover,

      handleChangeApiurlAuth,
      editableData,
      edit,
      save,
    };
  },
  components: {
    DragIcon,
    PlusOutlined,
    ReloadOutlined,
    ColumnHeightOutlined,
    SettingOutlined,
    FullscreenOutlined,
    FullscreenExitOutlined,
    Draggable,
    DragContainer,
    SearchRender,
    FormModal,
    [Badge.name]: Badge,
    EditOutlined,
    CheckOutlined,
  },
});
</script>
<style lang="less">
.editable-cell {
  position: relative;
  .editable-cell-input-wrapper,
  .editable-cell-text-wrapper {
    padding-right: 24px;
  }

  .editable-cell-text-wrapper {
    padding: 5px 24px 5px 5px;
  }

  .editable-cell-icon,
  .editable-cell-icon-check {
    position: absolute;
    right: 0;
    width: 20px;
    cursor: pointer;
  }

  .editable-cell-icon {
    display: none;
    margin-top: 4px;
  }

  .editable-cell-icon-check {
    line-height: 28px;
  }

  .editable-cell-icon:hover,
  .editable-cell-icon-check:hover {
    color: #108ee9;
  }

  .editable-add-btn {
    margin-bottom: 8px;
  }
}
.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}
</style>
